/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import moment from 'moment';
import { EditableField } from '@models/editable-field';
import { translate } from '@components/i18n';
import { formatMoney } from '@utils/money';
import { RootState } from '@redux/reducers';
import store from '@redux/store';
import { Moeda } from '@models/order/moedas/response';

const state: RootState = store.getState()

export const columns = [
    {
        title: translate('columns.numberItem'),
        dataIndex: 'numeroItem',
        sorter: true,
        width: '10%',
    },
    {
        title: translate('columns.startDate'),
        dataIndex: 'dataInicial',
        sorter: false,
        width: '15%',
        render: (_, record): React.ReactNode => {
            return (
                <span>{moment(record.dataInicial).format('DD/MM/YYYY')}</span>
            );
        },
    },
    {
        title: translate('columns.endDate'),
        dataIndex: 'dataFinal',
        sorter: false,
        width: '15%',
        render: (_, record): React.ReactNode => {
            return <span>{moment(record.dataFinal).format('DD/MM/YYYY')}</span>;
        },
    },
    {
        title: translate('columns.value'),
        dataIndex: 'valor',
        sorter: true,
        width: '10%',
        render: (_, record): React.ReactNode => {
            return <span>{formatMoney(state?.selectItems?.selectedMoeda?.simbolo, record.valor)}</span>;
        },
    },
    {
        title: translate('columns.moneyType'),
        dataIndex: 'codigoMoeda',
        sorter: true,
        width: '10%',
    },
];

interface editableFieldsProps {
    moedas?: Moeda[]
}

export function editableFields({moedas}: editableFieldsProps): EditableField[] {
    return [
        {
            name: 'numeroItem',
            label: translate('forms.labels.numberItem'),
            type: 'text',
            span: 12,
        },
        {
            name: 'dataInicial',
            label: translate('columns.startDate'),
            type: 'date',
            format: 'DD/MM/YYYY',
            span: 12,
        },
        {
            name: 'dataFinal',
            label: translate('columns.endDate'),
            type: 'date',
            format: 'DD/MM/YYYY',
            span: 12,
            rules: [
                ({ getFieldValue }) => ({
                    validator(_, value) {
                        if (
                            value &&
                            moment(getFieldValue('dataInicial')).isAfter(
                                moment(value),
                                'day',
                            )
                        ) {
                            return Promise.reject(
                                new Error(
                                    translate(
                                        'forms.rules.endDateCannotBeBeforeStart',
                                    ),
                                ),
                            );
                        }
                        return Promise.resolve();
                    },
                }),
            ],
        },
        {
            name: 'valor',
            label: translate('forms.labels.value'),
            type: 'number',
            span: 12,
        },
        {
            name: 'codigoMoeda',
            label: translate('forms.labels.moneyType'),
            type: 'select',
            options: moedas.map(moeda => ({id: moeda.codigo, name: `${moeda.codigo} - ${moeda.descricao}`})),
            span: 12,
        },
    ];
}
